import React from 'react';
import { Link } from 'react-router-dom';
import googlePlayBadge from '../assets/badges/google-play-badge.png';
import appStoreBadge from '../assets/badges/app-store-badge.svg';

const STORES = [
  {
    key: 'android',
    badge: googlePlayBadge,
    alt: 'Get it on Google Play',
    caption: 'Android 8.0 and up',
    href: null,
  },
  {
    key: 'ios',
    badge: appStoreBadge,
    alt: 'Download on the App Store',
    caption: 'iOS 15 and up',
    href: null,
  },
];

export default function Download() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Get the app</span>
        <h1 className="page-title section-gap">Download CascadeJoy</h1>
        <p className="page-subtitle">
          Play free on Android or iOS. Sign in on the web to keep your rewards and progress in sync.
        </p>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {STORES.map((store) => (
            <div key={store.key} className="rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
              {store.href ? (
                <a href={store.href} target="_blank" rel="noreferrer" className="inline-block">
                  <img src={store.badge} alt={store.alt} className="mx-auto h-12 w-auto" />
                </a>
              ) : (
                <span className="inline-block opacity-40 grayscale" aria-disabled="true">
                  <img src={store.badge} alt={store.alt} className="mx-auto h-12 w-auto" />
                </span>
              )}
              <p className="mt-2 text-xs font-semibold text-slate-500">{store.caption}</p>

              {!store.href && (
                <span className="mt-3 inline-flex items-center justify-center rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500">
                  Coming soon
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-5 text-sm text-slate-500 shadow-sm sm:p-6">
          Not live in the stores just yet — check back soon, or{' '}
          <Link to="/support" className="font-bold text-[var(--brand-primary)] hover:underline">
            contact support
          </Link>{' '}
          to be notified at launch.
        </div>

        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
